<template>
  <GenericReport
    ref="report"
    class="maxh-1bar clean-list"
    hide-header
    orientation="horizontal"
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ vehicleIds: syntheticVid }"
    @rowClicked="showRowDetails"
  >
    <template v-slot:topbar-extra>
      <DetailsDialog ref="detailsDialog" />
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from '../../rdevents-history/rdevents-columns'
import DetailsDialog from '../../rdevents-history/DetailsDialog.vue'

export default {
  tabTitle: 'Eventos',
  tabGroup: 'Veículo',
  components: {
    GenericReport,
    DetailsDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec }
  },
  computed: {
    reportSpec() {
      let apiBase = `/rawdata-events`
      return {
        code: 'rawdataEvents',
        title: 'Eventos',
        apiBase,
        filters: [
          'DateRange',
          { type: 'RDEventType', prefix: 'types', noSuffix: true },
          { type: 'Keywords', prefix: 'str0', label: 'str0' },
          { type: 'Keywords', prefix: 'str1', label: 'str1' }
        ]
      }
    },

    syntheticVid() {
      let oid = this.value.organizationId,
        vid = this.value.vehicleId

      return oid * 10000 + vid
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
